import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './styles/SignupConfirmation.css';

const SignupConfirmation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loginMode = location.state?.loginMode;

  useEffect(() => {
    if (!loginMode) navigate('/login');
  }, [navigate, loginMode]);

  return (
    <div className="signup-confirmation-container">
      <div className="confirmation-modal">
        <button className="modal-close" onClick={() => navigate('/login')}>×</button>
        <div className="modal-accent"></div>
        <div className="modal-body">
          <div className="modal-icon">✉️</div>
          <h1 className="modal-title">Verification Link Sent!</h1>
          <p className="modal-message">
            {loginMode === 'custom'
              ? "We've sent a verification link to your email. Please check your inbox and click the link to verify your account."
              : "Your Google account has been successfully linked! Please proceed to login."}
          </p>
          <button className="modal-btn" onClick={() => navigate('/login')}>
            Back to Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupConfirmation;
